<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />

    <!-- Breadcrumb y ayuda -->
    <div class="mb-3">
      <div class="row align-items-center">
        <div class="col-11">
          <div class="breadcrumb-container">
            <template v-if="p_idAtencion !== 0">
              <router-link to="/atencion">Atenciones</router-link>
              &rsaquo;
              <router-link
                :to="{
                  name: 'AtencionForm',
                  state: { idAtencion: p_idAtencion }
                }"
              >
                Atención {{ p_numero }}
              </router-link>
              &rsaquo; Alergias
            </template>
            <template v-else>
              <router-link to="/persona">Personas</router-link>
              &rsaquo;
              <router-link :to="'/personaform/' + p_idPersona">
                {{ datoPersona.nombreCompleto }}
              </router-link>
              &rsaquo; Alergias
            </template>
          </div>
        </div>
        <div class="col-1 text-end">
          <button class="btn-help" type="button" title="Abrir ayuda"
            @click="showModalHelp = true"
            aria-label="Abrir ayuda de alergias">
            <span class="material-symbols-outlined">help</span>
          </button>
        </div>
      </div>
    </div>

    <hr />

    <Modal v-model:modelValue="showModalHelp" title="Ayuda — Alergias del Paciente">
      <AyudaAlergiaPers />
    </Modal>

    <!-- Bloque: Datos de la Persona -->
    <div class="d-flex justify-content-between align-items-center mb-2">
      <b>Datos del Paciente</b>
      <button class="btn btn-link p-0 text-decoration-none"
        @click.prevent="mostrarBloque = !mostrarBloque">
        <span class="material-symbols-outlined align-middle">
          {{ mostrarBloque ? 'expand_less' : 'expand_more' }}
        </span>
        {{ mostrarBloque ? 'Mostrar menos' : 'Mostrar más información' }}
      </button>
    </div>

    <div class="form-card mb-3">
      <div class="mb-3">
        <div class="row align-items-center">
          <div class="col-7">
            <label class="col-form-label">Nombre</label>
            <input type="text" class="form-control" v-model="datoPersona.nombreCompleto" disabled />
          </div>
          <div class="col-3">
            <label class="col-form-label">{{ datoPersona.tipoIdenNombre }}</label>
            <input type="text" class="form-control" v-model="datoPersona.documento" disabled />
          </div>
        </div>
      </div>

      <!-- Sección colapsable -->
      <div v-if="mostrarBloque">
        <hr class="my-2" />
        <div class="mb-3">
          <div class="row align-items-center">
            <div class="col-2"><label class="col-form-label">Email</label></div>
            <div class="col-6">
              <input type="text" class="form-control" v-model="datoPersona.email" disabled />
            </div>
            <div class="col-2"><label class="col-form-label">Estado Civil</label></div>
            <div class="col-2">
              <input type="text" class="form-control" v-model="datoPersona.estadoCivilNombre" disabled />
            </div>
          </div>
        </div>
        <div class="mb-3">
          <div class="row align-items-center">
            <div class="col-2"><label class="col-form-label">Localidad</label></div>
            <div class="col-6">
              <input type="text" class="form-control" v-model="datoPersona.localidadNombre" disabled />
            </div>
            <div class="col-2"><label class="col-form-label">Teléfono</label></div>
            <div class="col-2">
              <input type="text" class="form-control" v-model="datoPersona.telefono" disabled />
            </div>
          </div>
        </div>
        <div class="mb-3">
          <div class="row">
            <div class="col-2"><label class="col-form-label">Primer Nombre</label></div>
            <div class="col-4">
              <input type="text" class="form-control" v-model="datoPersona.primerNombre" disabled />
            </div>
            <div class="col-2"><label class="col-form-label">Segundo Nombre</label></div>
            <div class="col-4">
              <input type="text" class="form-control" v-model="datoPersona.segundoNombre" disabled />
            </div>
          </div>
        </div>
        <div class="mb-3">
          <div class="row">
            <div class="col-2"><label class="col-form-label">Primer Apellido</label></div>
            <div class="col-4">
              <input type="text" class="form-control" v-model="datoPersona.primerApellido" disabled />
            </div>
            <div class="col-2"><label class="col-form-label">Segundo Apellido</label></div>
            <div class="col-4">
              <input type="text" class="form-control" v-model="datoPersona.segundoApellido" disabled />
            </div>
          </div>
        </div>
        <div class="mb-3">
          <div class="row">
            <div class="col-2"><label class="col-form-label">Fecha de Nacimiento</label></div>
            <div class="col-4">
              <input type="text" class="form-control"
                :value="getFormattedDate(datoPersona.fechaNac)" disabled />
            </div>
            <div class="col-2"><label class="col-form-label">Sexo</label></div>
            <div class="col-4">
              <input type="text" class="form-control" :value="sexoDecodificado" disabled />
            </div>
          </div>
        </div>
        <div class="mb-3">
          <div class="row">
            <div class="col-12">
              <label class="col-form-label">Dirección</label>
              <input type="text" class="form-control" v-model="datoPersona.direccion" disabled />
            </div>
          </div>
        </div>
        <div class="mb-3">
          <div class="row">
            <div class="col-2">
              <label class="form-label">Id. Persona</label>
              <input type="text" class="form-control" v-model="datoPersona.idPersona" disabled />
            </div>
            <div class="col-2">
              <label class="form-label">Id. Empresa</label>
              <input type="text" class="form-control" v-model="datoPersona.idEmpresa" disabled />
            </div>
            <div class="col-2">
              <label class="form-label">Id. Usuario Reg.</label>
              <input type="text" class="form-control" v-model="datoPersona.idUsuarioReg" disabled />
            </div>
            <div class="col-2">
              <label class="form-label">Fecha Reg.</label>
              <input type="text" class="form-control"
                :value="getFormattedDate(datoPersona.fechaReg)" disabled />
            </div>
            <div class="col-2">
              <label class="form-label">Id. Usuario Act.</label>
              <input type="text" class="form-control" v-model="datoPersona.idUsuarioAct" disabled />
            </div>
            <div class="col-2">
              <label class="form-label">Fecha Act.</label>
              <input type="text" class="form-control" v-model="datoPersona.fechaAct" disabled />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- DataTable de Alergias -->
    <DataTable
      :data="alergiaperss"
      :columns="columnasAlergia"
      idField="idAlergiaPers"
      :mostrarBotonTodos="true"
      :mostrarBotonNuevo="true"
      :mostrarBotonExcel="true"
      :mostrarInfo="false"
      :mostrarEditar="true"
      :mostrarVer="false"
      :mostrarEliminar="false"
      mensajeVacio="No hay alergias registradas."
      @refresh="getDataTodos"
      @create="abrirModalCrear"
      @edit="row => abrirModalEditar(row.idAlergiaPers)"
    />

    <!-- Modal Alergia -->
    <Teleport to="body">
      <div class="modal fade" id="ventanaModal" tabindex="-1"
        aria-labelledby="modalAlergiaLabel" aria-hidden="true" ref="modalRef">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-primary text-white">
              <h5 class="modal-title" id="modalAlergiaLabel">
                <span class="material-symbols-outlined align-middle me-2" style="font-size:20px">
                  {{ btnCrear_det ? 'add_circle' : 'edit' }}
                </span>
                {{ titulo }}
              </h5>
              <button type="button" class="btn-close btn-close-white"
                @click="cerrarModal" aria-label="Cerrar"></button>
            </div>

            <div class="modal-body">
              <div class="mb-3">
                <div class="row align-items-center">
                  <div class="col-3"><label class="col-form-label">Alergia</label></div>
                  <div class="col-9">
                    <select class="form-select" v-model="datoAlergiaPers.idAlergia">
                      <option v-for="a in alergias" :value="a.idAlergia" :key="a.idAlergia">
                        {{ a.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row align-items-center">
                  <div class="col-3"><label class="col-form-label">Fecha de Diagnóstico</label></div>
                  <div class="col-9">
                    <input type="date" class="form-control"
                      v-model="datoAlergiaPers.fechaDiag" required />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row align-items-center">
                  <div class="col-3"><label class="col-form-label">Severidad</label></div>
                  <div class="col-9">
                    <select class="form-select" v-model="datoAlergiaPers.severidad">
                      <option value="Leve">Leve</option>
                      <option value="Moderada">Moderada</option>
                      <option value="Severa">Severa</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row align-items-center">
                  <div class="col-3"><label class="col-form-label">Observación</label></div>
                  <div class="col-9">
                    <input type="text" class="form-control"
                      v-model="datoAlergiaPers.observacion"
                      style="text-transform:uppercase" required />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row align-items-center">
                  <div class="col-3"><label class="col-form-label">Fecha de Registro</label></div>
                  <div class="col-9">
                    <input type="text" class="form-control"
                      :value="getFormattedDate(datoAlergiaPers.fechaReg)" disabled />
                  </div>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button class="btn btn-secondary btn-sm" @click="cerrarModal">
                <span class="material-symbols-outlined align-middle" style="font-size:18px">close</span>
                Cancelar
              </button>
              <button v-if="btnCrear_det" class="btn btn-success btn-sm"
                @click.prevent="guardarAlergiaPers">
                <span class="material-symbols-outlined align-middle" style="font-size:18px">save</span>
                Guardar
              </button>
              <button v-if="btnEditar_det" class="btn btn-primary btn-sm"
                @click.prevent="guardarEditAlergiaPers">
                <span class="material-symbols-outlined align-middle" style="font-size:18px">update</span>
                Actualizar
              </button>
            </div>
          </div>
        </div>
      </div>
    </Teleport>

    <Footer />
  </div>
</template>

<script>
import Layout          from '@/components/Layout.vue'
import Footer          from '@/components/Footer.vue'
import DataTable       from '@/components/DataTable.vue'
import AyudaAlergiaPers from '@/views/ayuda/AyudaAlergiaPers.vue'
import { validarForm } from '../../modules/validacionesForms.js'
import dateFormat      from '@/modules/dateFormat.js'
import api             from '@/services/api'
import { Modal }       from 'bootstrap'
import Swal            from 'sweetalert2'

export default {
  name: 'AlergiaPers',
  components: { Layout, Footer, DataTable, AyudaAlergiaPers },

  props: {
    p_idAtencion:     { type: Number, required: true },
    p_estadoAtencion: { type: String, required: true },
    p_numero:         { type: String, required: true },
    p_idPersona:      { type: Number, required: true },
  },

  data() {
    return {
      datoPersona:     {},
      mostrarBloque:   false,
      showModalHelp:   false,
      alergiaperss:    [],
      datoAlergiaPers: {},
      titulo:          '',
      btnCrear_det:    false,
      btnEditar_det:   false,
      modalInstance:   null,
      alergias:        [],
      columnasAlergia: [
        { field: 'alergiaNombre', label: 'Nombre' },
        { field: 'severidad',     label: 'Severidad' },
        { field: 'observacion',   label: 'Observación' },
        { field: 'fechaDiag',     label: 'Fecha Diagnóstico', format: (val) => dateFormat.getFormattedDate(val) },
      ],
    }
  },

  computed: {
    estadoPermitido() {
      return ['PENDIENTE', 'PROCESO'].includes(this.p_estadoAtencion)
    },
    sexoDecodificado() {
      const s = this.datoPersona.sexo
      if (s === 'M') return 'Masculino'
      if (s === 'F') return 'Femenino'
      return s || ''
    },
  },

  mounted() {
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    this.cargarPersona()
    this.getDataTodos()
    this.$nextTick(() => {
      if (this.$refs.modalRef) {
        this.modalInstance = new Modal(this.$refs.modalRef)
      }
    })
  },

  beforeUnmount() {
    if (this.modalInstance) this.modalInstance.dispose()
  },

  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date)
    },

    // ── Persona ───────────────────────────────────────────────────────────
    async cargarPersona() {
      try {
        const resp = await api.get(`/vwpersonas/${this.p_idPersona}`)
        this.datoPersona = resp.data
      } catch (err) {
        console.error('Error cargando persona:', err)
      }
    },

    // ── Alergias ──────────────────────────────────────────────────────────
    async getDataTodos() {
      try {
        const resp = await api.get(`/vwalergiaperss/idpersona/${this.p_idPersona}`)
        this.alergiaperss = resp.data.reverse()
      } catch (err) {
        console.error('Error cargando alergias:', err)
      }
    },

    validarFormDet() {
      return validarForm(
        this.datoAlergiaPers,
        ['idAlergia', 'fechaDiag', 'severidad'],
        ['Alergia', 'Fecha Diagnóstico', 'Severidad']
      )
    },

    async abrirModalCrear() {
      this.datoAlergiaPers = {}
      this.titulo          = 'Registrar alergia'
      this.btnCrear_det    = true
      this.btnEditar_det   = false
      await this.fetchAlergias()
      this.modalInstance?.show()
    },

    async abrirModalEditar(idAlergiaPers) {
      this.titulo        = 'Editar alergia'
      this.btnCrear_det  = false
      this.btnEditar_det = true
      await this.fetchAlergias()
      try {
        const resp = await api.get(`/vwalergiaperss/${idAlergiaPers}`)
        this.datoAlergiaPers = resp.data
      } catch (err) {
        console.error('Error cargando alergia:', err)
      }
      this.modalInstance?.show()
    },

    cerrarModal() {
      this.modalInstance?.hide()
    },

    async guardarAlergiaPers() {
      if (this.validarFormDet() !== 1) return
      try {
        this.datoAlergiaPers.idPersona = this.datoPersona.idPersona
        await api.post('/alergiaperss', this.datoAlergiaPers)
        this.cerrarModal()
        await Swal.fire({ icon: 'success', title: 'Guardado', text: 'Alergia registrada exitosamente.', timer: 2000, showConfirmButton: false })
        this.getDataTodos()
      } catch {
        Swal.fire({ icon: 'error', title: 'Error', text: 'Inténtelo de nuevo.' })
      }
    },

    async guardarEditAlergiaPers() {
      if (this.validarFormDet() !== 1) return
      try {
        await api.post('/alergiaperss', this.datoAlergiaPers)
        this.cerrarModal()
        await Swal.fire({ icon: 'success', title: 'Actualizado', text: 'Alergia actualizada exitosamente.', timer: 2000, showConfirmButton: false })
        this.getDataTodos()
      } catch {
        Swal.fire({ icon: 'error', title: 'Error', text: 'Inténtelo de nuevo.' })
      }
    },

    // ── Catálogos ─────────────────────────────────────────────────────────
    async fetchAlergias() {
      try {
        const r = await api.get('/alergias')
        this.alergias = r.data
      } catch (err) {
        console.error('Error cargando catálogo de alergias:', err)
      }
    },
  },
}
</script>

<style scoped>
.btn-help {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #0d6efd;
}
.btn-help .material-symbols-outlined {
  font-size: 32px;
  transition: color 0.2s;
}
.btn-help:hover .material-symbols-outlined {
  color: #0a58ca;
}
</style>
<style src="@/assets/css/listaRegistros.css" scoped></style>